import { useParams } from 'react-router-dom';
import FileManager from '../components/FileManager';

function MathsCycle() {
  const params = useParams();
  const cycleId = params.cycleId;  
  const folderId = "maths-" + cycleId;
  const folderName = cycleId + ". cyklus";

  return <>
    <FileManager folderId={folderId} folderName={folderName} />
  </>
}

export default MathsCycle;